/**
 * Blog URLs that changed after publication, mapped old slug -> current slug.
 *
 * Entries stay here permanently. A published URL keeps collecting links and search
 * impressions long after we stop pointing at it, so retiring one means redirecting it,
 * not deleting it.
 *
 * Rename in the admin and add the entry here in the same change: the redirect is only
 * correct once the article actually answers to the new slug.
 */
export const RETIRED_BLOG_SLUGS: Record<string, string> = {
  // Published straight from the editor with its draft slug (August 2026). The article is
  // the Android app / voice / sessions round-up, and "draft-73f5245b" was never meant to
  // be a public address.
  'draft-73f5245b': 'teamplay-android-app-voice-chat-and-sessions',
};
